import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useCart } from "../context/CartContext";
import "../styles/AIShop.css";

export default function AIShop() {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [messages, setMessages] = useState(() => {
  const saved = localStorage.getItem("ai_chat");
  return saved
    ? JSON.parse(saved)
    : [{ type: "text", from: "ai", text: "Hi! What do you want to buy? 🎤" }];
});

  const [products, setProducts] = useState([]);
  const [input, setInput] = useState("");

  const messagesEndRef = useRef(null);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [qty, setQty] = useState(1);

  const suggestionProducts = [...products]
.sort(() => 0.5 - Math.random())
.slice(0, 6);

// SEARCH
const handleSend = useCallback((msg) => {
  const text = msg || input;
  if (!text.trim()) return;

  if (selectedVariant && !isNaN(text)) {
    const qty = parseInt(text);

    setMessages(prev => [
      ...prev,
      { type: "text", from: "user", text },
      {
        type: "confirm",
        product: selectedProduct,
        variant: selectedVariant,
        qty
      }
    ]);

    setInput("");
    return;
  }

  const newMessages = [
    ...messages,
    { type: "text", from: "user", text },
  ];

  const search = text.toLowerCase();

  const results = products.filter(p =>
    p.name?.toLowerCase().includes(search) ||
    p.category?.toLowerCase().includes(search) ||
    p.brand?.toLowerCase().includes(search)
  );

  let reply;

  if (results.length > 0) {
    reply = {
      type: "products",
      items: results.slice(0, 10),
    };
  } else {
    reply = {
      type: "text",
      from: "ai",
      text: "No products found.",
    };
  }

  setMessages([...newMessages, reply]);
  setInput("");
}, [input, messages, products, selectedVariant, selectedProduct]);

  useEffect(() => {
  loadProducts();
}, []);

useEffect(() => {
  const clear = () => {
    handleNewChat();
  };

  window.addEventListener("ai_clear_chat", clear);

  return () => {
    window.removeEventListener("ai_clear_chat", clear);
  };
}, []);

useEffect(() => {
  const processQuery = () => {
    const query = localStorage.getItem("ai_query");

    if (query && products.length > 0) {
      handleSend(query);
      localStorage.removeItem("ai_query");
    }
  };

  processQuery();

  window.addEventListener("ai_query_update", processQuery);

  return () => {
    window.removeEventListener("ai_query_update", processQuery);
  };
}, [products, handleSend]);


useEffect(() => {
  localStorage.setItem("ai_chat", JSON.stringify(messages));
}, [messages]);

useEffect(() => {
  setTimeout(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });
  }, 50);
}, [messages]);

  const loadProducts = async () => {
    const snap = await getDocs(collection(db, "products"));

    const list = snap.docs.map(doc => ({
      product_id: doc.id,
      ...doc.data(),
    }));

    setProducts(list);
  };

  


  // PRODUCT CLICK
  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setSelectedVariant(null); // reset
    setQty(1);

    // if product has variants
    if (product.variants && product.variants.length > 0) {

      setMessages(prev => [
        ...prev,
        { type: "text", from: "ai", text: `Select variant for ${product.name}` },
        { type: "variants", items: product.variants }
      ]);

    } else {
      // no variant → ask qty
      setSelectedVariant({
        id: "default",
        name: "Default"
      });

      setMessages(prev => [
  ...prev,
  { type: "text", from: "ai", text: "Select quantity" },
{ type: "stepper" }
]);
    }
  };

  // VARIANT CLICK
  const handleVariantSelect = (variant) => {
  setSelectedVariant(variant);
  setQty(1); // FIX

  setMessages(prev => [
    ...prev,
    { type: "text", from: "user", text: variant.name },
    { type: "text", from: "ai", text: "Select quantity" },
    { type: "stepper" }
  ]);
};


  // ADD TO CART
  const handleAddToCart = (m) => {

  if (!m?.product || !m?.variant) return; // ✅ FIX

  const product = {
    product_id: m.product.product_id,
    name: m.product.name,
    brand: m.product.brand,
    image: m.product.image
  };

  const variant = {
    variantId: m.variant.id,
    size: m.variant.name,
    price: Number(m.variant.price || m.product.price || 0),
    image: m.product.image
  };

  for (let i = 0; i < m.qty; i++) {
    addToCart(product, variant);
  }

  setMessages(prev => [
    ...prev,
    {
      type: "text",
      from: "ai",
      text: "✅ Added to cart!"
    }
  ]);

  setSelectedProduct(null);
  setSelectedVariant(null);
};

const handleNewChat = () => {
  const fresh = [
    { type: "text", from: "ai", text: "Hi! What do you want to buy? 🎤" }
  ];

  setMessages(fresh);
  localStorage.removeItem("ai_chat");
  setSelectedProduct(null);
  setSelectedVariant(null);
  setQty(1);
};

  return (
    <div className="ai-wrap">

      <div className="ai-header">
  <div>
    <div className="ai-title">🤖 AI Shopping Assistant</div>
    <div className="ai-sub">Shop faster with AI</div>
  </div>

  
</div>

      <div className="ai-messages">

  <div className="ai-new-chat-row">
    <button className="ai-new-chat" onClick={handleNewChat}>
  ↺
</button>
  </div>

        {messages.length === 1 && suggestionProducts.length > 0 && (
  <div className="ai-suggestions-products">

    {suggestionProducts.map(p => (
      <div
        key={p.product_id}
        className="ai-suggestion-card"
        onClick={() => handleProductSelect(p)}
      >
        <img src={p.image} alt="" />
        <div>{p.name}</div>
      </div>
    ))}

  </div>
)}

        {messages.map((m,i)=>(
          <div key={i}>

            {m.type === "products" && (
              <div className="ai-products">
                {m.items.map(p=>(
                  <div
                    key={p.product_id}
                    className="ai-product-card"
                    onClick={()=>handleProductSelect(p)}
                  >
                    <img src={p.image} alt="" />
                    <div className="ai-product-info">
                      <div className="ai-product-name">{p.name}</div>
                      <div className="ai-product-price">
  ₹{p.price || p.variants?.[0]?.price || 0}
</div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {m.type === "variants" && (
              <div className="ai-variants">
                {m.items.map(v=>(
                  <div
                    key={v.id}
                    className="ai-variant"
                    onClick={()=>handleVariantSelect(v)}
                  >
                    {v.name}
                  </div>
                ))}
              </div>
            )}

            
{m.type === "stepper" && (
  <div className="ai-stepper">

    <div className="stepper-box">
      <button onClick={()=>setQty(q => Math.max(1, q-1))}>➖</button>
      <span>{qty}</span>
      <button onClick={()=>setQty(q => q+1)}>➕</button>
    </div>

    <button
      className="ai-add-btn"
      onClick={()=>{
  if(!selectedProduct) return;

  handleAddToCart({
    product: selectedProduct,
    variant: selectedVariant,
    qty
  });
}}
    >
      Add to Cart
    </button>

  </div>
)}

            {m.type === "confirm" && (
              <div className="ai-confirm">
                <div>{m.product.name}</div>
                <div>{m.variant.name}</div>
                <div>Qty: {m.qty}</div>

                <button
                  className="ai-checkout-btn"
                  onClick={()=>handleAddToCart(m)}
                >
                  🛒 Add to Cart
                </button>

                <button
                  className="ai-view-cart-btn"
                  onClick={()=>navigate("/cart")}
                >
                  🛍 View Cart
                </button>
              </div>
            )}

            {m.type === "text" && (
              <div className={`ai-bubble ${m.from==="user"?"ai-user":"ai-ai"}`}>
                {m.text}
              </div>
            )}

          </div>
        ))}

<div ref={messagesEndRef} />

      </div>

      {/* ✅ INPUT MUST BE HERE */}
<div className="ai-input-bar">

  <div className="ai-input-wrap">
    <input
      value={input}
      onChange={(e)=>setInput(e.target.value)}
      placeholder="chat with AI..."
      onKeyDown={(e)=>{
        if(e.key === "Enter"){
          handleSend();
        }
      }}
    />

    {input && (
      <button
        className="ai-clear"
        onClick={()=>setInput("")}
      >
        ×
      </button>
    )}
  </div>

  <button
    className="ai-send"
    onClick={()=>handleSend()}
  >
    ➤
  </button>

</div>
      
    </div>
  );
}